import { useEffect } from 'react';
import { getSupabase } from '@/hooks/useSupabase';

export default function AnalyticsScripts() {
  useEffect(() => {
    const loadAnalytics = async () => {
      try {
        const supabase = getSupabase();
        const { data } = await supabase
          .from('site_settings')
          .select('key, value')
          .in('key', ['analytics_ga4_id', 'analytics_clarity_id', 'analytics_hotjar_id']);

        if (!data || data.length === 0) return;

        const settings: Record<string, string> = {};
        data.forEach((row: any) => { settings[row.key] = row.value; });

        // GA4
        const ga4Id = settings['analytics_ga4_id'];
        if (ga4Id && ga4Id.trim()) {
          const gaScript = document.createElement('script');
          gaScript.async = true;
          gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id.trim()}`;
          document.head.appendChild(gaScript);

          gaScript.onload = () => {
            (window as any).dataLayer = (window as any).dataLayer || [];
            function gtag(...args: any[]) { (window as any).dataLayer.push(args); }
            (window as any).gtag = gtag;
            gtag('js', new Date());
            gtag('config', ga4Id.trim());
          };
        }

        // Microsoft Clarity
        const clarityId = settings['analytics_clarity_id'];
        if (clarityId && clarityId.trim()) {
          (function (c: any, l: any, a: string, r: string, i: string) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
            const t = l.createElement(r); t.async = true;
            t.src = 'https://www.clarity.ms/tag/' + i;
            const y = l.getElementsByTagName(r)[0];
            if (y && y.parentNode) y.parentNode.insertBefore(t, y);
          })(window, document, 'clarity', 'script', clarityId.trim());
        }

        // Hotjar
        const hotjarId = settings['analytics_hotjar_id'];
        if (hotjarId && hotjarId.trim()) {
          (function (h: any, o: any, t: string, j: string, a: any, r: any) {
            h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
            h._hjSettings = { hjid: parseInt(hotjarId.trim(), 10), hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script'); r.async = true;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            if (a) a.appendChild(r);
          })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
        }
      } catch {
        // analytics loading is non-critical
      }
    };

    loadAnalytics();
  }, []);

  return null;
}